<template>
    <flat-pickr
        v-model="dummy_value"
        :config="flatpickr_config"
        class="form-control rounded-none"
        placeholder="Choose Date"
        name="date">
    </flat-pickr>
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import 'flatpickr/dist/themes/material_blue.css';

export default {
  name: "DatePicker",
  components: {
    flatPickr
  },
  props: {
    enabled_default: {
      type: Boolean,
      default: true,
    },
    earliest_date: {
      type: String,
      default: ""
    },
    latest_date: {
      type: String,
      default: "",
    }
  },
  data() {
    return {
      dummy_value: "",
      from_date: new Date(),
      to_date: new Date(),
      livewire: {},
      flatpickr_config: {
        minDate: this.earliest_date,
        maxDate: this.latest_date,
        onClose: this.close,
      }
    }
  },
  mounted() {
    this.livewire = Livewire;
  },
  methods: {
    close(selectedDate, dateStr, instance) {
        this.date = selectedDate;
        this.livewire.emit('setDate', [this.date]);
      }
    }
}
</script>

<style scoped>

</style>
